interface KinAvatarProps {
  size?: "sm" | "md" | "lg";
  variant?: "light" | "dark";
}

const sizeMap = {
  sm: "w-10 h-10",
  md: "w-12 h-12",
  lg: "w-[78px] h-[78px]",
};

const fontSizeMap = {
  sm: "20px",
  md: "30px",
  lg: "46px",
};

const sparkleSize = {
  sm: { fontSize: "8px", top: "14%", right: "14%" },
  md: { fontSize: "10px", top: "14%", right: "14%" },
  lg: { fontSize: "14px", top: "14%", right: "14%" },
};

const KinAvatar = ({ size = "sm", variant = "light" }: KinAvatarProps) => {
  const gradient = variant === "dark"
    ? "bg-gradient-to-br from-kin-charcoal to-[#2C2A5A]"
    : "bg-gradient-to-br from-kin-periwinkle to-kin-elav";

  return (
    <div
      className={`${sizeMap[size]} ${gradient} rounded-[14px] flex items-center justify-center flex-shrink-0 relative`}
    >
      <span className="font-display text-primary-foreground leading-none mt-0.5 font-bold" style={{ fontSize: fontSizeMap[size] }}>K</span>
      <span
        className="absolute opacity-90"
        style={{ fontSize: sparkleSize[size].fontSize, top: sparkleSize[size].top, right: sparkleSize[size].right, color: "hsl(240 69% 74%)" }}
      >
        ✦
      </span>
    </div>
  );
};

export default KinAvatar;
